import React from 'react';
import { Section } from './shared';
const without = ['Clientes indecisos sin seguimiento', 'Renovaciones sin sistema de aviso', 'Sin guión para manejar objeciones', 'WhatsApp disponible 24/7', 'Trámites manuales todos los días', 'Sin sistema de referidos', 'Sin prompts para seguimiento'];
const realCost = ['Pólizas perdidas que ya eran tuyas', 'Cartera que se achica sola', 'Descuentos que te comen las comisiones', 'Domingos sin familia ni descanso', 'Horas perdidas que podrías usar vendiendo', 'El mismo ciclo el año que viene', 'Clientes que se pierden en silencio'];
export function CostOfInaction() {
  return <div className="w-full bg-navy-deep py-16 text-white sm:py-24" data-id="element-47" data-mp="3dpd5zio1j6p1">
      <Section data-id="element-48" data-mp="3in562zyu9z4b">
        <h2 className="text-center font-display text-2xl font-extrabold sm:text-4xl" data-id="element-49" data-mp="3inodhmqv5543">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-50" data-mp="3nocduz0zeyaz">
          <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6" data-id="element-51" data-mp="3skt4bzvnlor8">
            <h3 className="mb-4 font-display text-lg font-bold text-red-300" data-id="element-52" data-mp="3eg6gmava73jn">Sin Megapack</h3>
            <ul className="space-y-3" data-id="element-53" data-mp="39hmua9crzpqr">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[15px] text-blue-100/85" data-id="element-54" data-mp="39g21opa0ugvj">
                  <span aria-hidden="true" data-id="element-55" data-mp="34ik05jyc33xk">❌</span>
                  <span data-id="element-56" data-mp="30h6sd4bokqo0">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border border-gold/30 bg-white/[0.04] p-6" data-id="element-57" data-mp="11a759y8vcaz">
            <h3 className="mb-4 font-display text-lg font-bold text-gold-soft" data-id="element-58" data-mp="13eddyjm8nef">Costo real</h3>
            <ul className="space-y-3" data-id="element-59" data-mp="3sa7b2sf7a4e7">
              {realCost.map(item => <li key={item} className="flex items-start gap-2 text-[15px] text-blue-100/85" data-id="element-60" data-mp="3nftkd3bhglfv">
                  <span aria-hidden="true" data-id="element-61" data-mp="3jerlwope4dey">💸</span>
                  <span data-id="element-62" data-mp="js1gibi8f2pd">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-2xl space-y-4 text-center" data-id="element-63" data-mp="f1kzyij470ys">
          <p className="font-display text-xl font-bold text-white sm:text-2xl" data-id="element-64" data-mp="ez8alkb11obp">
            El próximo domingo puede ser diferente. O seguís apagando incendios, o empezás a liderar tu
            estudio.
          </p>
          <p className="text-[15px] leading-relaxed text-blue-100/80" data-id="element-65" data-mp="1zjdcckkbmueb">
            Los que entren hoy no solo compran el Megapack: entran al ecosistema de Librofy.store. Eso
            incluye acceso a futuros materiales exclusivos que iremos liberando para miembros.
          </p>
        </div>
      </Section>
    </div>;
}